import React from 'react';
import './ButtonLoader.css';

export default function ButtonLoader() {
    return (
        <div className="button-loader-container">
            <div className="loader_for_btn"></div>
        </div>
    );
};
